
export enum IntegrationsPageRoute {
    list = "/integrations",
    add = "/integrations/add",
    details = "/integrations/view/:platform",
    /** configuring an integration */
    configure = "/integrations/configure/:platform",
}



